import React, { useEffect } from 'lib/react';
import {
  EVPaper,
  EVGrid,
} from 'lib/components';
import { useTranslation, Trans } from 'lib/translation';
import useMediaQuery from 'hooks/useMediaQuery';
import { useDispatch, useSelector } from 'lib/redux';
import RetryScreen from 'commonComponents/retry-screen';
import PageNotFound from 'commonComponents/pageNotFound';
import ReportDetails from 'commonComponents/reportDetails/ReportDetails.component';
import Button from 'lib/components/button';
import { Link } from 'lib/router';
import {
  ORDER_HISTORY_ROUTE,
  SUPPORT_ROUTE,
} from 'constants/RouteConstants';
import Banner from 'commonComponents/banner';
import {
  SUCCESS, WARNING, ERROR,
} from 'constants/AppConstants';
import ReportsChangeStyles from './ReportsChangeStyles';
import loadReportsChangePage from './ReportsChange.action';
import ReportsChangeLoader from './ReportsChangeLoader';

function ReportsChange() {
  const classes = ReportsChangeStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadReportsChangePage());
  }, []);

  const {
    loading, loadError, reportDetails, notFound, reportsChangeBanner, reportId, topImage,
  } = useSelector((state) => state.reportsChange);

  if (loading) return <ReportsChangeLoader />;

  if (notFound) return <PageNotFound />;

  if (loadError) return <RetryScreen handleRetryButtonClick={() => dispatch(loadReportsChangePage())} />;

  return (
    <>
      {(reportsChangeBanner.severity === SUCCESS || reportsChangeBanner.severity === ERROR) && (
        <Banner
          data-testid="successBanner"
          severity={reportsChangeBanner.severity}
          message={reportsChangeBanner.message}
        />
      )}
      <EVPaper square={isMobile} className={classes.mainPaper}>
        {reportsChangeBanner.severity === WARNING && (
          <Banner
            data-testid="warningBanner"
            severity={reportsChangeBanner.severity}
            message={(
              <>
                {reportsChangeBanner.message}
                {' '}
                <Trans
                  i18nKey="reports_change__contact_customer_service"
                  components={{
                    a: (
                      <Link
                        style={{ color: '#007CAD', textDecoration: 'none' }}
                        to={SUPPORT_ROUTE}
                      >
                        Customer Service
                      </Link>
                    ),
                  }}
                />
              </>
            )}
            className={classes.warningAlert}
          />
        )}
        <EVGrid className={classes.detailsMapGrid}>
          {reportId && (
          <>
            <ReportDetails reportId={reportId} reportDetails={reportDetails} />
            <img
              className={classes.topImage}
              src={`data:image;base64,${topImage}`}
              alt={t('common__top_image')}
            />
          </>
          )}
        </EVGrid>
        <EVGrid className={classes.linksAndBtn}>
          <Button
            id="order-history-btn"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to={ORDER_HISTORY_ROUTE}
          >
            {t('report_details__back_to_order_history')}
          </Button>
        </EVGrid>
      </EVPaper>
    </>
  );
}

export default ReportsChange;
